/* stylelint-disable selector-max-compound-selectors */
/* cwc-tabbed-accordion */
$label-text-color: var(--cwc-tabbed-accordion-label-text-color, var(--base-font-color)) !default;
$label-on-desktop-text-color: var(--cwc-tabbed-accordion-label-on-desktop-text-color, #333) !default;
$label-background-color: var(--cwc-tabbed-accordion-label-background-color, #f2f2f2) !default;
$label-active-text-color: var(--cwc-tabbed-accordion-label-active-text-color, var(--base-font-color)) !default;
$label-on-desktop-active-text-color: var(
  --cwc-tabbed-accordion-label-on-desktop-active-text-color,
  var(--color-primary)
) !default;
$label-on-desktop-active-underline-color: var(
  --cwc-tabbed-accordion-label-on-desktop-active-underline-color,
  $label-on-desktop-active-text-color
) !default;
$label-active-background-color: var(--cwc-tabbed-accordion-label-background-color, #fff) !default;
$icon-text-color: var(--cwc-tabbed-accordion-arrow-text-color, var(--base-font-color)) !default;
$arrow-background-color: var(--cwc-tabbed-accordion-arrow-background-color, #ddd) !default;
$arrow-background-color-hover: var(--cwc-tabbed-accordion-arrow-background-color-hover, #eee) !default;

// csc-button
@use '~@cewe-designsystem-stylecomponents/button/button-old/flat' as floatButton;

// csc-breakpoints
@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints' as breakpoints;

/* cwc-tabbed-accordion */
:host {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  margin-top: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);

  > ul {
    display: none;
  }

  a,
  button {
    pointer-events: auto;
  }

  > hr {
    display: none;
    position: absolute;
    height: 2px;
    margin: 0;
    transition:
      left 0.3s ease-in-out,
      width 0.3s ease-in-out;
    border: 0;
    background-color: $label-on-desktop-active-underline-color;
    pointer-events: none;
  }

  slot[name='action-left-icon'],
  slot[name='action-right-icon'] {
    fill: currentColor;
    color: $icon-text-color;
  }

  > input {
    visibility: hidden;
    position: absolute;
    width: 0;
    height: 0;
    margin: 0;
    opacity: 0;
    pointer-events: none;
  }

  > label {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1rem;
    border-bottom: 1px solid var(--color-white, #fff);
    background-color: $label-background-color;
    color: $label-text-color;
    cursor: pointer;

    * {
      pointer-events: none;
    }

    .icon {
      width: 1.1rem;
      fill: currentColor;
    }
  }

  cwc-tabbed-accordion-tab {
    position: relative;
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.75s ease-in-out;
    pointer-events: all;

    &[data-active] {
      max-height: 999px;
      transition: max-height 0.75s ease-in-out 0.75s;
    }

    ul {
      display: inline-table;
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;
      margin-left: -3rem;
      border-spacing: 0.5rem;
      border-collapse: separate;
      line-height: 1.45rem;

      /* stylelint-disable max-nesting-depth */
      li {
        display: table-row;
        margin-top: 0;
        margin-bottom: 0.5rem;
        font-size: 1rem;
        line-height: 1.4;
        white-space: normal;

        &::before {
          content: '▪';
          margin-right: 0.5rem;
        }

        * {
          display: inline;
        }
      }

      /* stylelint-enable max-nesting-depth */
    }
  }

  > label {
    .icon {
      display: block;
    }

    &[data-active] {
      background-color: $label-active-background-color;
      color: $label-active-text-color;
      font-weight: 600;

      .icon {
        display: none;
      }
    }
  }

  /* stylelint-disable order/order */
  @include breakpoints.breakpoint(md) {
    justify-content: center;
    box-shadow: none;

    cwc-tabbed-accordion-tab {
      display: unset;
      visibility: hidden;
      position: absolute;
      order: 99;
      max-height: none;
      overflow: auto;
      transition: opacity 0.5s ease-in;
      opacity: 0;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
      pointer-events: none;

      &[data-active] {
        visibility: visible;
        position: relative;
        order: 98;
        transition: opacity 0.5s ease-in;
        opacity: 1;
      }
    }

    > hr {
      display: block;
    }

    > label {
      justify-content: flex-start;
      width: auto;
      margin: 0 0.5rem;
      padding: 0.25rem 0.5rem;
      border-bottom: 2rem solid transparent;
      background-color: transparent;
      color: $label-on-desktop-text-color;
      text-transform: uppercase;

      .icon {
        display: none;
      }

      &[data-active] {
        background-color: transparent;
        color: $label-on-desktop-active-text-color;
        font-weight: 600;
      }
    }

    > ul {
      display: flex;
      position: absolute;
      z-index: 100;
      top: 60px;
      justify-content: space-between;
      width: 100%;
      height: calc(100% - 60px);
      margin: 0;
      padding: 0;
      pointer-events: none;

      /* stylelint-disable max-nesting-depth */
      li {
        display: flex;
        position: absolute;
        align-items: center;
        width: 40px;
        height: 100%;
        background: $arrow-background-color;
        pointer-events: all;

        slot > *,
        ::slotted(*) {
          width: 1.1rem;
        }

        &:hover,
        &:active,
        &:focus {
          background: $arrow-background-color-hover;
        }

        &:first-of-type {
          left: 0;
        }

        &:last-of-type {
          right: 0;
        }

        &[data-hidden] {
          display: none;
        }
      }

      /* stylelint-enable max-nesting-depth */
    }
  }

  @media only screen and (min-width: 1024px) and (max-width: 1102px) {
    > label {
      font-size: 0.925rem;
    }
  }
  /* stylelint-enable order/order */
}

:host([data-arrow-left-disabled]) {
  > ul li:first-of-type {
    display: none;
  }
}

:host([data-arrow-right-disabled]) {
  > ul li:last-of-type {
    display: none;
  }
}
